// #173. A password change from Settings has no Cognito trigger, so after it
// the app asks the API to email the notice. One flow for both hosts: the
// host injects its Cognito call and its request.

type Poster = (
  path: string,
  opts: { method: "POST"; body: unknown },
) => Promise<unknown>;

/** Changes the password, then asks for the notice without waiting for it.
 *  Throws only when the change fails: a failed notice is not the athlete's
 *  error once the password has changed. */
export async function changePasswordAndNotify(opts: {
  changePassword: () => Promise<void>;
  apiFetch: Poster;
  /** The app's current language tag; the server falls back to English. */
  locale: string | undefined;
}): Promise<void> {
  await opts.changePassword();
  Promise.resolve()
    .then(() =>
      opts.apiFetch("/api/me/password-changed", {
        method: "POST",
        body: { locale: opts.locale },
      }),
    )
    .catch(() => undefined);
}
